import { useState, useEffect } from 'react';
import { SendMessage } from './App.js';
import icobackblue from './img/ico-backblue.svg';
import playpause from './img/playpause.svg';
import iconextsong from './img/ico-nextsong.svg';
import icoreplay from './img/ico-replay.svg';
import icoclosewhite from './img/ico-closeWhite.svg';
import icopause from './img/ico-pause.svg';
import icodelblue from './img/ico-delBlue.svg';
import gameCn from './img/game-cn.jpg';
import gameEn from './img/game-en.jpg';
import strings from './strings.js'
import axios from 'axios';
import { toast } from 'react-toastify';
import swfLogo from './swf/logo.swf';
import game1Logo from './swf/logo/1.png';
import menu from './swf/menu.swf';
import swf1 from './swf/1.swf';
import swf2 from './swf/2.swf';
import swf3 from './swf/3.swf';
import swf4 from './swf/4.swf';
import swf5 from './swf/5.swf';
import swf6 from './swf/6.swf';
import swf7 from './swf/7.swf';
import swf8 from './swf/8.swf';
import swf9 from './swf/9.swf';
import swf10 from './swf/10.swf';
import swf11 from './swf/11.swf';
import swf12 from './swf/12.swf';
import swf13 from './swf/13.swf';
import swf14 from './swf/14.swf';
import swf15 from './swf/15.swf';
import swf16 from './swf/16.swf';
import swf17 from './swf/17.swf';
import swf18 from './swf/18.swf';
import swf19 from './swf/19.swf';
import swf20 from './swf/20.swf';
import swf21 from './swf/21.swf';
import swf23 from './swf/23.swf';
import swf24 from './swf/24.swf';
import swf25 from './swf/25.swf';
import { Flash } from 'react-ruffle'

const API_URL = "https://www.starboxkod.com/api";

const SelectingGameCard = ({ stateVer, onClick, lang }) => {
    const [tapped, setTapped] = useState(false);
    const [swf, setSwf] = useState(swfLogo);
    const [showFlash, setShowFlash] = useState(true); // Add state for the key
    const [selectedCategory, setSelectedCategory] = useState(1);
    const [selectedButton, setSelectedButton] = useState(1);

//20241217add
    const [currentSwf, setCurrentSwf] = useState("logo");
//20241217add

    function gameReady() {
        // Call function1
        const flashObject = document.getElementById("abc");
        //flashObject.setP1(2);
        console.log(flashObject);
    }
    useEffect(() => {
        //changeSWF
        window.letsAlertMe = (message) => {
            if (message === "menu") {
                setSwf(menu);
                setCurrentSwf(menu);
            }
            setShowFlash(false);
            setTimeout(() => {
                setShowFlash(true);
            }, 0); // Adjust the delay time (in milliseconds) as needed
        };


        //Flash.setCredit(5);
        window.JSsetA = (message) => {
            console.log(message);
            switch (message) {
                case 1: //topGames
                    setSelectedCategory(1);
                    document.getElementById("abc").ASsetP1(2);
                    document.getElementById("abc").ASsetP2(3);
                    document.getElementById("abc").ASsetP3(4);
                    document.getElementById("abc").ASsetP4(5);
                    document.getElementById("abc").ASsetP5(6);
                    document.getElementById("abc").ASsetP6(7);
                    
                    document.getElementById("abc").ASsetPAGENUM(false);
                    break;
                case 2: //cards
                    setSelectedCategory(2);
                    document.getElementById("abc").ASsetP1(3);
                    document.getElementById("abc").ASsetP2(5);
                    document.getElementById("abc").ASsetP3(7);
                    document.getElementById("abc").ASsetP4(8);
                    document.getElementById("abc").ASsetP5(9);
                    document.getElementById("abc").ASsetP6(11);
                    document.getElementById("abc").ASsetPAGENUM(false);
                    break;
                case 3: //puzzlez
                    setSelectedCategory(3);
                    document.getElementById("abc").ASsetP1(6);
                    document.getElementById("abc").ASsetP2(10);
                    document.getElementById("abc").ASsetP3(12);
                    document.getElementById("abc").ASsetP4(16);
                    document.getElementById("abc").ASsetP5(20);
                    document.getElementById("abc").ASsetP6(22);
                    document.getElementById("abc").ASsetPAGENUM(true);
                    //document.getElementById("abc").ASsetP1(24);
/*
                    Flash.setCredit(0);
                    Flash.setISPLAY(true);
                    Flash.setPAGENUM(true);
                    Flash.setGAMEPIC(1);*/
                    break;
                case 4: //strategy
                setSelectedCategory(4);
                    document.getElementById("abc").ASsetP1(2);
                    document.getElementById("abc").ASsetP2(15);
                    document.getElementById("abc").ASsetP3(17);
                    document.getElementById("abc").ASsetP4(18);
                    document.getElementById("abc").ASsetP5(1);
                    document.getElementById("abc").ASsetP6(1);
                    document.getElementById("abc").ASsetPAGENUM(false);
                    break;
                case 5: //action
                setSelectedCategory(5);
                    document.getElementById("abc").ASsetP1(4);
                    document.getElementById("abc").ASsetP2(14);
                    document.getElementById("abc").ASsetP3(1);
                    document.getElementById("abc").ASsetP4(1);
                    document.getElementById("abc").ASsetP5(1);
                    document.getElementById("abc").ASsetP6(1);
                    document.getElementById("abc").ASsetPAGENUM(false);
                    break;
                case 6: //action
                setSelectedCategory(6);
                    document.getElementById("abc").ASsetP1(4);
                    document.getElementById("abc").ASsetP2(9);
                    document.getElementById("abc").ASsetP3(10);
                    document.getElementById("abc").ASsetP4(12);
                    document.getElementById("abc").ASsetP5(13);
                    document.getElementById("abc").ASsetP6(14);
                    document.getElementById("abc").ASsetPAGENUM(true);
                    //document.getElementById("abc").ASsetP1(25);
                    //document.getElementById("abc").ASsetP2(26);
                    break;
                case 7: //tourament
                setSelectedCategory(7);
                    document.getElementById("abc").ASsetP1(12);
                    document.getElementById("abc").ASsetP2(25);
                    document.getElementById("abc").ASsetP3(1);
                    document.getElementById("abc").ASsetP4(1);
                    document.getElementById("abc").ASsetP5(1);
                    document.getElementById("abc").ASsetP6(1);
                    document.getElementById("abc").ASsetPAGENUM(false);

                    break;
            }
        };


        window.JSsetScore = (message) => {
            //should get an INT when the player leaves the game, can be 0 if they quit immediately
            // check if high score, if high score, prompt to enter name, else just quit to main menu
        }

        window.JSsetPLAY = (message) => {
            //letsAlertMe();
            // Increment selectedButton value by 1 to get the next swf number 
            console.log("play" + message);
            switch(message) {
                case 2:
                    setSwf(swf1);
                    break;
                case 3:
                    setSwf(swf2);
                    break;
                case 4:
                    setSwf(swf3);
                    break;
                case 5:
                    setSwf("https://starboxkod.com/swf/4/4.swf");
                    break;
                case 6:
                    setSwf(swf5);
                    break;
                case 7:
                    setSwf(swf6);
                    break;
                case 8:
                    setSwf(swf7);
                    break;
                case 9:
                    setSwf(swf8);
                    break;
                case 10:
                    setSwf(swf9);
                    break;
                case 11:
                    setSwf(swf10);
                    break;
                case 12:
                    setSwf(swf11);
                    break;
                case 13:
                    setSwf(swf12);
                    break;
                case 14:
                    setSwf(swf13);
                    break;
                case 15:
                    setSwf(swf14);
                    break;
                case 16:
                    setSwf(swf15);
                    break;
                case 17:
                    setSwf(swf16);
                    break;
                case 18:
                    setSwf(swf17);
                    break;
                case 19:
                    setSwf(swf18);
                    break;
                case 20:
                    setSwf(swf19);
                    break;
                case 21:
                    setSwf(swf20);
                    break;
                case 22:
                    setSwf(swf21);
                    break;
                case 24:
                    setSwf(swf23);
                    break;
                case 25:
                    setSwf(swf24);
                    break;
                case 26:
                    setSwf(swf25);
                    break;
            }            
            setShowFlash(false);
            setTimeout(() => {
                setShowFlash(true);
            }, 0);
        }

        window.JSsetB = (message) => {
            console.log(message);
            setSelectedButton(message);
            //tell me which gameNumber they need, then I'll provide:
            switch (message) {
                case 1://firstButton
                    document.getElementById("abc").ASsetCREDIT("20");
                    //document.getElementById("abc").ASsetGAMEPIC(12);
                    document.getElementById("abc").ASsetHELP("To play this game");
                    document.getElementById("abc").ASsetTN1("adam");
                    document.getElementById("abc").ASsetTN2("jabber");
                    document.getElementById("abc").ASsetTC1("11820");
                    document.getElementById("abc").ASsetTC2("9820");
                    document.getElementById("abc").ASsetTD1("05/11/21");
                    //document.getElementById("abc").ASsetTD2("26/04/22");
                    break;
                case 2://secondButton
                    break;
                case 3://thirdButton
                    break;
                case 4://fourthButton
                    break;
                case 5://fifthButton
                    break;
                case 6://sixthButton
                    break;
                case 7:
                    break;
            }
        }



/*
        window.sendScoreToServer = (message) => {
            if (message === "menu") {
                setSwf(menu);
            }
            setShowFlash(false);
            setTimeout(() => {
                setShowFlash(true);
            }, 0); // Adjust the delay time (in milliseconds) as needed
        };
*/

/*
        window.gamePlayedMinus1 = (message) => {
            if (message === "menu") {
                setSwf(menu);
            }
            setShowFlash(false);
            setTimeout(() => {
                setShowFlash(true);
            }, 0); // Adjust the delay time (in milliseconds) as needed
        };
*/

    }, []);
    

    return (
        <div className="LMAOselecting">
            <div className="mui-overlay"
                onClick={(e) => { e.preventDefault(); /* onClick()83 19 5vw 5vw */ }}
            ></div>
            <div className="actions-sheet2"
                style={{ paddingBottom: "5px", paddingTop: "5px", paddingLeft: "5px", paddingRight: "5px", left: "1vw", right: "1vw" }}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation(); }}>
                <div className="controlCardClose">
                    <a className="controlCardCloseIcon" onClick={(e) => { e.preventDefault(); onClick() }}>
                        <img
                            src={icoclosewhite}
                            alt="close"
                        />
                    </a>
                </div>


                {tapped ? <>
                    {showFlash ? <>
                    <span>
                        <Flash id="abc" src={swf} config={{
                            allowScriptAccess: true,
                            contextMenu: "off",
                            autoplay: "on",
                            preloader: false,
                            parameters: {
                                // FlashVars
                                //topname
                                TN1: "albert",
                                TN2: "slay",
                                TC1: "3214",
                                TD1: "01/02/20"
                            }
                        }}>
                            <p>Please wait...</p>
                        </Flash>
                        </span>
                    </> : <>
                    
                    </>}
                    
                </> : <>
                    <span onClick={(e) => {
                        e.preventDefault();
                        setTapped(true);
                    }}>
                        <img
                            style={{
                                width: "100%",
                                maxHeight: "80vh",
                                objectFit: "contain"
                            }}
                            src={lang ? gameCn : gameEn}
                            alt="record"
                        />
                    </span>
                </>}
            </div>
        </div>
    );
}

export default SelectingGameCard;
